import { ClientType } from '@common/model/client/clientType';
import { createEventFactory } from '@cp/shared/tracking';
import { CAREER_ID_TO_CAREER_NAME, clientTypeToEventParam } from 'src/shared/tracking';

export const ClientTypeModalOpen = createEventFactory({
  subject: 'client',
  object: 'type',
  action: 'open',
  result: 'success',
  goalId: 'poyavlenie_popapa_vybora_poisk_raboty_ili_poisk_specialista',
  goalName: 'Появление попапа выбора "Поиск работы" или "Поиск специалиста"',
  nonInteraction: true,
});

export const ClientSelectCareer = createEventFactory<Record<string, string>, number>(
  {
    subject: 'client',
    object: 'career',
    action: 'select',
    goalId: 'vybor_varianta_kategorii_specialista_v_popape',
    goalName: 'Выбор варианта категории специалиста в попапе',
  },
  (careerId) => ({
    'категория': CAREER_ID_TO_CAREER_NAME[careerId],
  }),
);

export const registrationClientTypeSelect = createEventFactory<Record<string, string>, { type: ClientType }>(
  {
    subject: 'registration',
    object: 'type',
    action: 'select',
    goalId: 'vybor_varianta_ya_ishchu_pri_registracii',
    goalName: 'Выбор варианта "Я ищу" при регистрации',
  },
  ({ type }) => {
    return { type: type === ClientType.Employer ? 'помощника' : 'работу' };
  },
);

export const registrationCareerModal = createEventFactory({
  subject: 'client',
  object: 'career',
  action: 'open',
  result: 'success',
  nonInteraction: true,
  goalId: 'poyavlenie_popapa_kategoriya_specialista_',
  goalName: 'Появление попапа "Категория специалиста"',
});

export const registraionShowAddress = createEventFactory({
  subject: 'client',
  object: 'address',
  action: 'open',
  result: 'success',
  nonInteraction: true,
  goalId: 'poyavlenie_popapa_adres_pri_registracii',
  goalName: 'Появление попапа "Адрес" при регистрации',
});

export const registrationCitySelect = createEventFactory<{ city: number }>({
  subject: 'client',
  object: 'city',
  action: 'select',
  goalId: 'vybor_goroda_pri_registracii',
  goalName: 'Выбор города при регистрации',
});

export const registrationStreetSelect = createEventFactory({
  subject: 'client',
  object: 'address',
  action: 'select',
  goalId: 'vybor_ulicy_pri_registracii',
  goalName: 'Выбор улицы при регистрации',
});

export const registrationLocationNext = createEventFactory({
  subject: 'registration',
  object: 'location',
  action: 'click',
  result: 'finish',
  goalId: 'nazhatie_knopki_dalee_pri_vybore_lokacii',
  goalName: 'Нажатие кнопки "Далее" при выборе локации',
});

export const registrationWelcomeShow = createEventFactory({
  subject: 'registration',
  object: 'welcome',
  action: 'open',
  result: 'success',
  goalId: 'poyavlenie_popapa_s_instrukciej',
  goalName: 'Появление попапа с инструкцией',
});
export const registrationStartClick = createEventFactory({
  subject: 'registration',
  object: 'start',
  action: 'click',
  goalId: 'nazhatie_na_knopku_davajte_nachnem',
  goalName: 'Нажатие на кнопку "Давайте начнем!"',
});

export const acquaintancePopupVisible = createEventFactory({
  subject: 'registration',
  object: 'acquaintance',
  action: 'open',
  result: 'success',
  nonInteraction: true,
  goalName: 'Появление попапа "Как к вам обращаться?"',
  goalId: 'poyavlenie_popapa_kak_k_vam_obrashchatsya',
});

export const aquaintanceSubmit = createEventFactory({
  subject: 'registration',
  object: 'aquaintance',
  action: 'submit',
  goalId: 'nazhatie_na_knopku_sohranit_i_prodolzhit',
  goalName: 'Нажатие на кнопку "Сохранить и продолжить"',
});

export const afterAllShow = createEventFactory({
  subject: 'registration',
  object: 'afterAll',
  action: 'open',
  result: 'success',
  nonInteraction: true,
  goalId: 'poyavlenie_popapa_s_dalnejshimi_shagami',
  goalName: 'Появление попапа с дальнейшими шагами',
});

export const createResumeClick = createEventFactory({
  subject: 'registration',
  object: 'createResume',
  action: 'click',
  goalName: 'Нажатие на кнопку "Создать анкету"',
  goalId: 'nazhatie_na_knopku_sozdat_anketu',
});

export const registrationFinish = createEventFactory<Record<string, string>, { type?: ClientType }>(
  {
    subject: 'registration',
    action: 'finish',
    result: 'success',
    nonInteraction: true,
  },
  ({ type }) => ({ ...clientTypeToEventParam(type) }),
);

export const registrationStart = createEventFactory<Record<string, string>, { type?: ClientType }>(
  {
    subject: 'registration',
    action: 'start',
    nonInteraction: true,
  },
  ({ type }) => ({ ...clientTypeToEventParam(type) }),
);
